import Layout from "../../components/structure/layout";
import SupplierRegistrationForm from "../../components/general/SupplierRegistrationForm";

const ModuleRegistrazione = ({ siteConfig, storyBlok }) => {
  return (
    <Layout siteConfig={siteConfig} storyBlok={storyBlok} forceDarkNav={true}>
      <SupplierRegistrationForm />
    </Layout>
  );
};

export default ModuleRegistrazione;
